<template>
  <v-row class="d-flex justify-center">
    <v-col v-for="(item, index) in dialogAccountDel" :key="index" class="d-flex justify-center">
      <v-btn text dark @click.stop="dialog = true">
        <span class="d-flex primary--text text-capitalize text-caption">{{ item.btn }}</span>
      </v-btn>
      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title class="text-h6 ml-n1">{{ item.title }}</v-card-title>
          <v-card-text>{{ item.text }}</v-card-text>
          <v-col cols="12">
            <div>
              <div class="ma-auto position-relative" style="max-width: 200px">
                <span class="d-flex text-caption justify-center mb-2">{{ item.text2 }}</span>
              </div>
              <v-row>
                <v-col cols="12">
                  <div>
                    <div class="ma-auto position-relative" style="max-width: 300px">
                      <v-otp-input
                        v-model="otp"
                        length="6"
                        :disabled="loading"
                        @finish="onFinish"
                      ></v-otp-input>
                      <v-overlay absolute :value="loading">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                      </v-overlay>
                    </div>

                    <span class="d-flex justify-center text-caption black--text mt-7">
                      {{ text }}
                    </span>
                  </div>
                </v-col>
                <v-col cols="12" class="d-flex justify-center">
                  <v-btn
                    class="secundary2 white--text mt-2 text-capitalize"
                    @click="reSendCode"
                    disabled
                    v-if="timerActive === true"
                  >
                    Reenviar código
                    <span class="text-lowercase">({{ timerCount }} seg.)</span>
                  </v-btn>
                  <v-btn
                    class="secundary2 white--text mt-2 text-capitalize"
                    @click="reSendCode"
                    v-else
                  >
                    Reenviar código
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card> 
      </v-dialog>
    </v-col>
    <v-snack-bar :snackbar="snackbar" />
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'VDialogAccountDel',
  components: {
    VSnackBar,
  },
  props: ['dialogAccountDel'],
  data() {
    return {
      dialog: false,
      loading: false,
      otp: '',
      text: '',
      timerActive: false,
      timerCount: 0,
      snackbar: {}
    };
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters('proAccountPage', ['statusPro']),
    ...mapGetters('patAccountPage', ['statusPat']),
    ...mapGetters('patAccountPage', ['statusDel']),
    ...mapGetters('usersCodeVerif', ['usersCodeVerifGen']),
  },
  methods: {
    ...mapActions('usersCodeVerif', ['getUsersCodeVerifGen']),

    async onFinish() {
      this.loading = true;

      let model = {};
      model.otp = this.otp;

      if (this.$route.name === 'my-account') {
        this.$store.dispatch('proAccountPage/delAccount', { model }).then(
          () => {
            if (this.statusPro === true) {
              setTimeout(() => {
                this.loading = false;
                this.text = 'Correcto. Se te envió un email para confirmar el cambio.';
              }, 1500);
              this.otp = '';
              this.text = '';
            } else if (this.statusPro === false) {
              setTimeout(() => {
                this.loading = false;
                this.text = 'Código de verificación es incorrecto';
              }, 1500);
            }
          },
          () => {
            setTimeout(() => {
              this.loading = false;
              this.text = 'Código de verificación es incorrecto';
            }, 1500);
          }
        );
      } else if (this.$route.name === 'my-account-pat') {
        this.$store.dispatch('patAccountPage/delAccount', { model }).then(
          () => {
            if (this.statusDel === true) {
              setTimeout(() => {
                this.loading = false;
                this.text = 'Correcto. Se te envió un email para confirmar el cambio.';
              }, 1500);
              this.otp = '';
              this.text = '';
              setTimeout(() => {
                this.$router.push({ name: 'HomePro' });
              }, 4000);
            } else if (this.statusDel === false) {
              setTimeout(() => {
                this.loading = false;
                this.text = 'Código de verificación es incorrecto';
              }, 1500);
            }
          },
          () => {
            setTimeout(() => {
              this.loading = false;
              this.text = 'Código de verificación es incorrecto';
            }, 1500);
          }
        );
      }
    },
    async reSendCode() {
      this.timerCount = 30;
      this.timerActive = true;
      setTimeout(() => {
        this.timerActive = false;
        this.timerCount = 0;
      }, 30000);

      const type = 'Pat';

      let model = {};
      model.type = type;

      await this.$store.dispatch('usersCodeVerif/getUsersCodeVerifGen', model);
      const usersCodeVerifGen = this.usersCodeVerifGen;

      if (!usersCodeVerifGen) {
        setTimeout(() => {
          this.loading = false;
          this.text = 'Hubo un error al enviar el código; inténtelo nuevamente.';
        }, 3500);
      }

      if (usersCodeVerifGen === true) {
        setTimeout(() => {
          this.loading = false;
          this.text = 'Código de verificación reenviado';
          this.snackbar = true;
        }, 3500);
        this.snackbar.content = 'Código de verificación reenviado';
      }
      this.otp = '';
      this.text = ' ';
    },
  },
};
</script>
